import { DeleteExternalContactRequestSchema, DeleteExternalContactResponseSchema } from './delete-external-contact.schema';
/**
 * Delete External Contact Endpoint Contract
 * Deletes an external contact by ID
 */ export const deleteExternalContactContract = {
    method: 'DELETE',
    path: '/api/v2/external-contact/:id',
    description: 'Delete an external contact by ID',
    requestSchema: DeleteExternalContactRequestSchema,
    responseSchema: DeleteExternalContactResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'External contact not found'
        }
    }
};

//# sourceMappingURL=delete-external-contact.contract.js.map